/* chartist-plugin-tooltip 0.0.17
 * Copyright © 2016 Markus Padourek
 * Free to use under the WTFPL license.
 * http://www.wtfpl.net/
 */

 /**
  * MODIFIED FROM SOURCE
  */
 /* global Chartist */
 (function (window, document, Chartist) {
     'use strict';

     var defaultOptions = {
         currency: undefined,
         currencyFormatCallback: undefined,
         formatter: undefined,
         tooltipOffset: {
             x: 0,
             y: -20
         },
         anchorToPoint: false,
         appendToBody: false,
         class: undefined,
         pointClass: 'ct-point'
     };

     Chartist.plugins = Chartist.plugins || {};
     Chartist.plugins.tooltip = function (options) {
         options = Chartist.extend({}, defaultOptions, options);

         return function tooltip(chart) {
             var tooltipSelector = options.pointClass;
             if (chart instanceof Chartist.Bar) {
                 tooltipSelector = 'ct-bar';
             } else if (chart instanceof Chartist.Pie) {
                 if (chart.options.donut) {
                     tooltipSelector = 'ct-slice-donut';
                 } else {
                     tooltipSelector = 'ct-slice-pie';
                 }
             }

             var $chart = chart.container;
             var $toolTip = $chart.querySelector('.chartist-tooltip');
             if (!$toolTip) {
                 $toolTip = document.createElement('div');
                 $toolTip.className = (!options.class) ? 'chartist-tooltip' : 'chartist-tooltip ' + options.class;
                 if (!options.appendToBody) {
                     $chart.appendChild($toolTip);
                 } else {
                     document.body.appendChild($toolTip);
                 }
             }
             var height = $toolTip.offsetHeight;
             var width = $toolTip.offsetWidth;

             hide($toolTip);

             function on(event, selector, callback) {
                 $chart.addEventListener(event, function (e) {
                     if (!selector || hasClass(e.target, selector))
                     callback(e);
                 });
             }

             on('mouseover', tooltipSelector, function (event) {
                 var $point = event.target;
                 var tooltipText = '';

                 var isPieChart = (chart instanceof Chartist.Pie) ? $point : $point.parentNode;
                 var seriesName = (isPieChart) ? $point.parentNode.getAttribute('ct:meta') || $point.parentNode.getAttribute('ct:series-name') : '';
                 var meta = $point.getAttribute('ct:meta') || seriesName || '';
                 var hasMeta = !!meta;
                 var value = $point.getAttribute('ct:value');

                 if (options.transformTooltipTextFnc && typeof options.transformTooltipTextFnc === 'function') {
                     value = options.transformTooltipTextFnc(value);
                 }

                 if (options.tooltipFnc && typeof options.tooltipFnc === 'function') {
                     tooltipText = options.tooltipFnc(meta, value);
                 } else {
                     if (options.metaIsHTML) {
                         var txt = document.createElement('textarea');
                         txt.innerHTML = meta;
                         meta = txt.value;
                     }

                     meta = '<span class="chartist-tooltip-meta">' + meta + '</span>';

                     if (hasMeta) {
                         tooltipText += meta + '<br>';
                         } else {
                             // For Pie Charts also take the labels into account
                             // Could add support for more charts here as well!
                             if (chart instanceof Chartist.Pie) {
                                 var label = next($point, 'ct-label');
                                 if (label) {
                                     tooltipText += text(label) + '<br>';
                                     }
                                 }
                             }

                             if (value) {
                                 if (options.currency) {
                                     if (options.currencyFormatCallback != undefined) {
                                         value = options.currencyFormatCallback(value, options);
                                     } else {
                                         value = options.currency + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
                                     }
                                 }
                                 if (options.formatter != undefined) {
                                     value = options.formatter(value, options);
                                 }
                                 value = '<span class="chartist-tooltip-value">' + value + '</span>';
                                 tooltipText += value;
                             }
                         }

                         if(tooltipText) {
                             $toolTip.innerHTML = tooltipText;
                             setPosition(event);
                             show($toolTip);

                             // Remember height and width to avoid wrong position in IE
                             height = $toolTip.offsetHeight;
                             width = $toolTip.offsetWidth;
                         }
                     });

                     on('mouseout', tooltipSelector, function () {
                         hide($toolTip);
                     });

                     on('mousemove', null, function (event) {
                         if (false === options.anchorToPoint)
                         setPosition(event);
                     });

                     function setPosition(event) {
                         height = height || $toolTip.offsetHeight;
                         width = width || $toolTip.offsetWidth;
                         var offsetX = - width / 2 + options.tooltipOffset.x
                         var offsetY = - height + options.tooltipOffset.y;
                         var anchorX, anchorY;

                         if (!options.appendToBody) {
                             var box = $chart.getBoundingClientRect();
                             var left = event.pageX - box.left - window.pageXOffset ;
                             var top = event.pageY - box.top - window.pageYOffset ;

                             if (true === options.anchorToPoint && event.target.x2 && event.target.y2) {
                                 anchorX = parseInt(event.target.x2.baseVal.value);
                                 anchorY = parseInt(event.target.y2.baseVal.value);
                             }

                             $toolTip.style.top = (anchorY || top) + offsetY + 'px';
                             $toolTip.style.left = (anchorX || left) + offsetX + 'px';
                         } else {
                             $toolTip.style.top = event.pageY + offsetY + 'px';
                             $toolTip.style.left = event.pageX + offsetX + 'px';
                         }
                     }
                 }
             };

             function show(element) {
                 if(!hasClass(element, 'tooltip-show')) {
                     element.className = element.className + ' tooltip-show';
                 }
             }

             function hide(element) {
                 var regex = new RegExp('tooltip-show' + '\\s*', 'gi');
                 element.className = element.className.replace(regex, '').trim();
             }

             function hasClass(element, className) {
                 return (' ' + element.getAttribute('class') + ' ').indexOf(' ' + className + ' ') > -1;
             }

             function next(element, className) {
                 do {
                     element = element.nextSibling;
                 } while (element && !hasClass(element, className));
                 return element;
             }

             function text(element) {
                 return element.innerText || element.textContent;
             }

         } (window, document, Chartist));


         /**
          * Chartist.js plugin to pre fill donuts with animations
          * author: moxx
          * author-url: https://github.com/moxx/chartist-plugin-fill-donut
          *
          */
         (function (document, Chartist) {
             'use strict';

             var defaultOptions = {
                 fillClass: 'ct-fill-donut',
                 label: {
                     html: 'div',
                     class: 'ct-fill-donut-label'
                 },
                 items: [{}]
             };

             Chartist.plugins = Chartist.plugins || {};
             Chartist.plugins.fillDonut = function (options) {
                 options = Chartist.extend({}, defaultOptions, options);
                 return function fillDonut(chart) {
                     if (chart instanceof Chartist.Pie) {
                         var $chart = chart.container;
                         $chart.style.position = 'relative';
                         var $svg;

                         var drawDonut = function(data) {
                             if (data.type === 'slice') {
                                 if (data.index === 0) {
                                     $svg = $chart.querySelector('svg');
                                 }

                                 var $clone = data.group._node.cloneNode(true);
                                 options.fillClass.split(" ").forEach(function (className) {
                                     $clone.setAttribute('class', $clone.getAttribute('class') + ' ' + className);
                                 });

                                 [].forEach.call($clone.querySelectorAll('path'), function (el) {
                                     [].forEach.call(el.querySelectorAll('animate'), function (node) {
                                         node.parentNode.removeChild(node);
                                     });

                                     el.removeAttribute('stroke-dashoffset');
                                 });

                                 $svg.insertBefore($clone, $svg.childNodes[0]);

                             }
                         };

                         chart.on('draw', function (data) {
                             drawDonut(data);
                         });

                         chart.on('created', function (data) {
                             var itemIndex = 0;

                             if (chart.options.fillDonutOptions) {
                                 options = Chartist.extend({}, options, chart.options.fillDonutOptions);
                                 drawDonut(data);
                             }

                             [].forEach.call(options.items, function (thisItem) {
                                 var $wrapper = document.createElement(options.label.html);
                                 options.label.class.split(" ").forEach(function (className) {
                                     if ($wrapper.classList) {
                                         $wrapper.classList.add(className);
                                     } else {
                                         $wrapper.className += ' ' + className;
                                     }
                                 });
                                 var item = Chartist.extend({}, {
                                     class: '',
                                     id: '',
                                     content: 'fillText',
                                     position: 'center', //bottom, top, left, right
                                     offsetY: 0, //top, bottom in px
                                     offsetX: 0 //left, right in px
                                 }, thisItem);


                                 if (item.id.length > 0) {
                                     $wrapper.setAttribute('id', item.id);
                                 }
                                 if (item.class.length > 0) {
                                     $wrapper.setAttribute('class', item.class);
                                 }

                                 [].forEach.call($chart.querySelectorAll('*[data-fill-index$="fdid-' + itemIndex + '"]'), function (node) {
                                     node.parentNode.removeChild(node);
                                 });
                                 $wrapper.setAttribute('data-fill-index', 'fdid-' + itemIndex);
                                 itemIndex += 1;

                                 $wrapper.insertAdjacentHTML('beforeend', item.content);
                                 $wrapper.style.position = 'absolute';
                                 $chart.appendChild($wrapper);

                                 var cWidth = Math.ceil($chart.offsetWidth / 2);
                                 var cHeight = Math.ceil($chart.clientHeight / 2);
                                 var wWidth = Math.ceil($wrapper.offsetWidth / 2);
                                 var wHeight = Math.ceil($wrapper.clientHeight / 2);

                                 var style = {
                                     bottom: {
                                         bottom: 0 + item.offsetY + "px",
                                         left: (cWidth - wWidth) + item.offsetX + "px"
                                     },
                                     top: {
                                         top: 0 + item.offsetY + "px",
                                         left: (cWidth - wWidth) + item.offsetX + "px"
                                     },
                                     left: {
                                         top: (cHeight - wHeight) + item.offsetY + "px",
                                         left: 0 + item.offsetX + "px"
                                     },
                                     right: {
                                         top: (cHeight - wHeight) + item.offsetY + "px",
                                         right: 0 + item.offsetX + "px"
                                     },
                                     center: {
                                         top: (cHeight - wHeight) + item.offsetY + "px",
                                         left: (cWidth - wWidth) + item.offsetX + "px"
                                     }
                                 };

                                 Chartist.extend($wrapper.style, style[item.position]);
                             });
                         });
                     }
                 };
             };
         }(document, Chartist)); // jshint ignore:line


/* chartist-plugin-axistitle 0.0.1
 * Copyright © 2015 Alex Stanbury
 * Free to use under the WTFPL license.
 * http://www.wtfpl.net/
 */

!function(a,b){"function"==typeof define&&define.amd?define([],function(){return a.returnExportsGlobal=b()}):"object"==typeof exports?module.exports=b():a["Chartist.plugins.ctAxisTitle"]=b()}(this,function(){return function(a,b,c){"use strict";var d={axisTitle:"",axisClass:"ct-axis-title",offset:{x:0,y:0},textAnchor:"middle",flipText:!1},e={xAxis:d,yAxis:d};c.plugins=c.plugins||{},c.plugins.ctAxisTitle=function(a){return a=c.extend({},e,a),function(b){b.on("created",function(b){if(!a.axisX.axisTitle&&!a.axisY.axisTitle)throw new Error("ctAxisTitle plugin - You must provide at least one axis title");if(!b.axisX&&!b.axisY)throw new Error("ctAxisTitle plugin can only be used on charts that have at least one axis");var d,e,f;if(a.axisX.axisTitle&&b.axisX&&(d=b.axisX.axisLength/2+b.options.axisY.offset+b.options.chartPadding.left,e=b.options.chartPadding.top,"end"===b.options.axisY.position&&(d-=b.options.axisY.offset),"end"===b.options.axisX.position&&(e+=b.axisY.axisLength),f=new c.Svg("text"),f.addClass(a.axisX.axisClass),f.text(a.axisX.axisTitle),f.attr({x:d+a.axisX.offset.x,y:e+a.axisX.offset.y,"text-anchor":a.axisX.textAnchor}),b.svg.append(f,!0)),a.axisY.axisTitle&&b.axisY){d=0,e=b.axisY.axisLength/2+b.options.chartPadding.top,"start"===b.options.axisX.position&&(e+=b.options.axisX.offset),"end"===b.options.axisY.position&&(d=b.axisX.axisLength);var g="rotate("+(a.axisY.flipTitle?-90:90)+", "+d+", "+e+")";f=new c.Svg("text"),f.addClass(a.axisY.axisClass),f.text(a.axisY.axisTitle),f.attr({x:d+a.axisY.offset.x,y:e+a.axisY.offset.y,transform:g,"text-anchor":a.axisY.textAnchor}),b.svg.append(f,!0)}})}}}(window,document,Chartist),Chartist.plugins.ctAxisTitle});
//# sourceMappingURL=chartist-plugin-axistitle.min.js.map
